<footer class="contain">

    <mat-divider></mat-divider>

    <mat-toolbar class="toolbar-bg">
        
        <mat-divider></mat-divider>

        <span class="nav-span flex-position">
            <mat-icon>copyright</mat-icon>
            <h6 class="footer-links">Easy-Xchange</h6>
        </span>

        <span class="fill-remaining-space"></span>

        <span class="nav-span flex-position">
            <h6 class="footer-links">CAD</h6>
        </span>
    </mat-toolbar>
</footer>